import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Checkbox } from "../ui/checkbox";
import DictateButton from "../DictateButton";

export const Field = ({ label, tid, ...props }) => (
  <div className="space-y-1.5">
    <Label>{label}</Label>
    <Input data-testid={tid} className="border-stone-300 bg-white" {...props} />
  </div>
);

export const Area = ({ label, tid, ...props }) => (
  <div className="space-y-1.5">
    <div className="flex items-center justify-between gap-2">
      <Label>{label}</Label>
      {props.onChange && (
        <DictateButton testid={tid ? `${tid}-dictate` : undefined}
          value={props.value}
          onReplace={(t) => props.onChange({ target: { value: t } })}
          onText={(t) => props.onChange({ target: { value: (props.value ? props.value + " " : "") + t } })} />
      )}
    </div>
    <Textarea rows={3} data-testid={tid} className="border-stone-300 bg-white" {...props} />
  </div>
);

export const CheckGroup = ({ label, options, values, onChange, tidPrefix }) => (
  <div className="space-y-2">
    <Label>{label}</Label>
    <div className="flex flex-wrap gap-x-6 gap-y-2.5 rounded-lg border border-stone-200 bg-white p-4">
      {options.map((opt) => (
        <label key={opt} className="flex cursor-pointer items-center gap-2 text-sm text-stone-700"
          data-testid={`${tidPrefix}-${opt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
          <Checkbox
            checked={(values || []).includes(opt)}
            onCheckedChange={(checked) =>
              onChange(checked ? [...(values || []), opt] : (values || []).filter((v) => v !== opt))
            }
          />
          {opt}
        </label>
      ))}
    </div>
  </div>
);

export const Section = ({ title, desc, children }) => (
  <div className="rounded-lg border border-stone-200 bg-white p-6 shadow-sm">
    <h3 className="font-heading text-lg font-semibold text-stone-900">{title}</h3>
    {desc && <p className="mb-4 mt-0.5 text-xs text-stone-500">{desc}</p>}
    <div className="mt-4 grid grid-cols-1 gap-5 md:grid-cols-2">{children}</div>
  </div>
);

export const Radio = ({ label, options, value, onChange, tid }) => (
  <div className="space-y-1.5">
    <Label>{label}</Label>
    <div className="flex flex-wrap gap-1.5" data-testid={tid}>
      {options.map((o) => (
        <button key={o} type="button" onClick={() => onChange(value === o ? "" : o)}
          data-testid={`${tid}-${o.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`rounded-md border px-3 py-1.5 text-sm transition-all ${
            value === o ? "border-primary bg-primary/10 font-medium text-primary" : "border-stone-200 bg-white text-stone-500 hover:border-stone-400 hover:text-stone-800"
          }`}>{o}</button>
      ))}
    </div>
  </div>
);
